// extracted by mini-css-extract-plugin
module.exports = {"root":"device-card_root__39hWS","imgBgStyle":"device-card_imgBgStyle__1iN8b","data":"device-card_data__1pyc2","title":"device-card_title__18Ufe","type":"device-card_type__3YNcV"};